import { render, staticRenderFns } from "./SubtotalPanel.vue?vue&type=template&id=133e676a&"
import script from "./SubtotalPanel.vue?vue&type=script&lang=js&"
export * from "./SubtotalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports